module.exports = __webpack_public_path__ + "98334fcaa404c0eb8b223bc7507584d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/rabbit-in-hat-right.png
// module id = 2877
// module chunks = 0